import BreakpointsEnum from '../enums/breakpointsEnum';

$(function () {
    let App = window.App;
    App.productAccessories = {};
    App.productAccessories.ajax = false; 

    let $modal = $('#productAccessoriesModal');
    let $productsContainer = $modal.find('.products-container');

    function setPagination(view = undefined) {
        let $pagination = $modal.find('#productAccessoriesPagination');

        if (view) {
            if ($pagination.length) {
                $pagination.replaceWith(view);
            } else {
                $productsContainer.after(view);
            }
        } else {
            $pagination.remove();
        }
    }

    function setActiveCategory(category_id, openModal) {
        let $buttons = $modal.find('.categories-list .btn');

        $buttons.removeClass('active');

        if (category_id) {
            let $button = $buttons.filter(`[data-category-id="${category_id}"]`);

            if (openModal) {
                $buttons.filter(':not([data-category-id])').after($button);
            }

            $button.addClass('active');
        } else {
            $buttons.filter(':not([data-category-id])').addClass('active');
        }
    }

    App.productAccessories.show = function (model_id, category_id = 0, openModal = false) {
        let prevRequest = App.productAccessories.ajax;

        App.productAccessories.ajax = $.ajax({
            type: 'POST',
            url: '/model/accessories',
            data: {
                model_id,
                category_id,
                modal: 1,
            },
            dataType: 'json',
            beforeSend: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }

                $productsContainer.addClass('is-loading');
            },
            success: function (response) {
                if (response.models_view) {
                    $productsContainer.html(response.models_view);
                }

                setPagination(response.pagination_view);
                setActiveCategory(category_id, openModal);
                window.App.lazyImageLoading();

                if (openModal) {
                    App.modal.open($modal);
                }
            },
            complete: function () {
                App.productAccessories.ajax = false;
                $productsContainer.removeClass('is-loading');
            },
        });
    }

    $(document).on('click', '#productAccessoriesPagination button[data-next-page]', function () {
        let $this = $(this);

        if ($this.hasClass('is-loading')) {
            return false;
        }

        $.ajax({
            type: 'POST',
            url: $this.attr('data-next-page'),
            beforeSend: function () {
                $this.addClass('is-loading');
            },
            success: function (response) {
                if (response.models_view) {
                    $productsContainer.append(response.models_view);
                }

                setPagination(response.pagination_view);
                window.App.lazyImageLoading();
            },
            complete: function () {
                $this.removeClass('is-loading');
            }
        });
    });

    $(window).on('load resize', () => {
        if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop, BreakpointsEnum.tablet].includes(window.App.getBreakpoint())) {
            App.modal.closeOpenModal($modal);
        }
    });
});